enum ScreenTarget {
  hybridGoogleMap = "HYBRID_GOOGLE_MAP",
  curatedMap = "CURATED_MAP",
  inAppLink = "IN_APP_LINK",
}

export default ScreenTarget;
